<div class="py-4 px-0">
  <div class="container">
    <div class="row">
      <div class="col">
        <app-privacy-policy></app-privacy-policy>
      </div>
    </div>
    <!--/.row-->
  </div>
</div>
